var map = {
	"./editorBaseApi": [
		2806
	],
	"./editorBaseApi.js": [
		2806
	],
	"./editorSimpleWorker": [
		6722
	],
	"./editorSimpleWorker.js": [
		6722
	],
	"./editorWorker": [
		3412,
		792
	],
	"./editorWorker.js": [
		3412,
		792
	],
	"./editorWorkerHost": [
		1978
	],
	"./editorWorkerHost.js": [
		1978
	],
	"./findSectionHeaders": [
		2743
	],
	"./findSectionHeaders.js": [
		2743
	],
	"./getIconClasses": [
		5286,
		792
	],
	"./getIconClasses.js": [
		5286,
		792
	],
	"./languageFeatureDebounce": [
		3603,
		792
	],
	"./languageFeatureDebounce.js": [
		3603,
		792
	],
	"./languageFeatures": [
		8058,
		792
	],
	"./languageFeatures.js": [
		8058,
		792
	],
	"./languageFeaturesService": [
		2529,
		792
	],
	"./languageFeaturesService.js": [
		2529,
		792
	],
	"./languageService": [
		8207,
		792
	],
	"./languageService.js": [
		8207,
		792
	],
	"./languagesAssociations": [
		1440,
		792
	],
	"./languagesAssociations.js": [
		1440,
		792
	],
	"./languagesRegistry": [
		3871,
		792
	],
	"./languagesRegistry.js": [
		3871,
		792
	],
	"./markerDecorations": [
		6490,
		792
	],
	"./markerDecorations.js": [
		6490,
		792
	],
	"./markerDecorationsService": [
		8329,
		792
	],
	"./markerDecorationsService.js": [
		8329,
		792
	],
	"./model": [
		2794,
		792
	],
	"./model.js": [
		2794,
		792
	],
	"./modelService": [
		7305,
		792
	],
	"./modelService.js": [
		7305,
		792
	],
	"./resolverService": [
		9174,
		792
	],
	"./resolverService.js": [
		9174,
		792
	],
	"./semanticTokensDto": [
		1356,
		792
	],
	"./semanticTokensDto.js": [
		1356,
		792
	],
	"./semanticTokensProviderStyling": [
		580,
		792
	],
	"./semanticTokensProviderStyling.js": [
		580,
		792
	],
	"./semanticTokensStyling": [
		5967,
		792
	],
	"./semanticTokensStyling.js": [
		5967,
		792
	],
	"./semanticTokensStylingService": [
		3560,
		792
	],
	"./semanticTokensStylingService.js": [
		3560,
		792
	],
	"./textModelSync/textModelSync.impl": [
		6453
	],
	"./textModelSync/textModelSync.impl.js": [
		6453
	],
	"./textModelSync/textModelSync.protocol": [
		1056,
		792
	],
	"./textModelSync/textModelSync.protocol.js": [
		1056,
		792
	],
	"./textResourceConfiguration": [
		3212,
		792
	],
	"./textResourceConfiguration.js": [
		3212,
		792
	],
	"./treeSitterParserService": [
		6556,
		792
	],
	"./treeSitterParserService.js": [
		6556,
		792
	],
	"./treeViewsDnd": [
		6079,
		792
	],
	"./treeViewsDnd.js": [
		6079,
		792
	],
	"./treeViewsDndService": [
		1272,
		792
	],
	"./treeViewsDndService.js": [
		1272,
		792
	],
	"./unicodeTextModelHighlighter": [
		4403
	],
	"./unicodeTextModelHighlighter.js": [
		4403
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3288;
module.exports = webpackAsyncContext;